/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-25 13:07:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-05 16:53:01
 * @FilePath: /src/app/(payment)/payment/components/BillingAddress/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { fetchCustomerAddress } from '@/api/account';
import { Address } from '@/api/types/public';
import Checkbox from '@/components/Form/Checkbox';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';
import { getAddressRules } from '@/utils/form-rule';
import { isEmpty } from '@/utils/tools';
import { useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { usePaymentStore } from '../../store';
import { AddressActionType } from '../Address';
import AddressComponentMobile from './components/AddressComponent.m';
import AddressComponentPc from './components/AddressComponent.pc';
import { useTranslations } from 'next-intl';

export interface BillingAddressProps {
  entrancePaymentScene: string;
  shippingAddress: Address;
  billingAddress: Address;
  paymentType: string;
  onBillingAddressChange: (address: Address) => void;
  onChangeBillFlag: (data: { flag: boolean; address?: Address }) => void;
  ref?: React.RefObject<any>;
  refer_page_name: string;
  refer_url_path: string;
}

export default function BillingAddress({
  entrancePaymentScene,
  shippingAddress,
  billingAddress,
  paymentType,
  onBillingAddressChange,
  onChangeBillFlag,
  ref,
  refer_page_name,
  refer_url_path,
}: BillingAddressProps) {
  const t = useTranslations('payment.BillingAddress');
  useImperativeHandle(ref, () => ({
    countryIsSame,
    getActionType,
  }));
  const addressComponentPcRef = useRef<any>(null);
  const { trackEvent } = useReporting();

  const [billFlag, setBillFlag] = useState(true);

  const _addressList = usePaymentStore((state) => state.addressList);
  const setAddressList = usePaymentStore((state) => state.setAddressList);
  const addressList = useMemo(() => {
    return _addressList.filter((item) => item.id !== shippingAddress?.id);
  }, [_addressList, shippingAddress]);

  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);

  const countryIsSame = useMemo(() => {
    if (billFlag) return true;
    if (
      !isEmpty(selectedAddress) &&
      !isEmpty(shippingAddress) &&
      selectedAddress.country_id !== shippingAddress?.country_id &&
      ['afterpay', 'klarna'].includes(paymentType)
    ) {
      return false;
    }
    return true;
  }, [billFlag, selectedAddress, shippingAddress, paymentType]);

  // 当 shippingAddress 改变时，将 selectedAddress 设置为空
  useEffect(() => {
    setSelectedAddress(null);
    setBillFlag(true);
  }, [shippingAddress?.id]);

  // 当selectedAddress变化时通知父组件. 注意：统一在这里调用父组件方法，其他地方不要调用，容易导致循环渲染
  useEffect(() => {
    // 调用父组件回调函数，通知地址变化
    onBillingAddressChange(selectedAddress);
  }, [selectedAddress]);

  useEffect(() => {
    onChangeBillFlag({
      flag: billFlag,
    });

    // true: 父组件设置跟shipping地址一样；false：不使用shipping地址，需要选择合适的账单地址
    if (!billFlag) {
      // 对于afterpay和klarna支付方式，账单地址国家必须与shipping地址国家相同
      const compatibleAddressList = ['afterpay', 'klarna'].includes(paymentType)
        ? addressList.filter((item) => item.country_id === shippingAddress?.country_id)
        : addressList;

      // 选择默认地址或第一个地址
      const newBillingAddress =
        compatibleAddressList.find((item) => item.default === 1) || compatibleAddressList[0] || {};

      // 通知父组件billFlag变化
      onChangeBillFlag({
        flag: billFlag,
      });
      setSelectedAddress(newBillingAddress);
    }
  }, [billFlag, addressList]);

  // 获取默认地址. result 地址列表通过参数传递进来，应对React的异步机制
  const getDefaultAddress = (id?: number, result?: Address[]) => {
    const newAddressList = result || addressList;
    if (id) {
      const defaultAddress = newAddressList.find((item) => item.id === id);
      if (defaultAddress) {
        setSelectedAddress(defaultAddress);
      }
      return;
    }
    const defaultAddress = newAddressList.find((item) => item.default === 1);
    if (defaultAddress) {
      setSelectedAddress(defaultAddress);
    } else if (newAddressList.length > 0) {
      setSelectedAddress(newAddressList[0]);
    } else {
      setSelectedAddress(null);
    }
  };

  const handleUpdateAddressList = async (id?: number) => {
    const res = await fetchCustomerAddress();
    if (res.code === 200) {
      const result =
        res.data.list?.map((item) => {
          const rules = getAddressRules(item, []);
          const addressItem = item as Address;
          addressItem.checked = !rules;
          addressItem.boxChecked = item.is_pobox === 1;
          return addressItem;
        }) || [];

      setAddressList(result);
      getDefaultAddress(id, result);
    }
  };

  const getActionType = () => {
    return addressComponentPcRef.current?.actionType || AddressActionType.DEFAULT;
  };

  const withoutAddress = useMemo(() => {
    const rule1 = isEmpty(billingAddress);
    const rule2 = addressList.length === 0;

    return rule1 || rule2;
  }, [addressList, billingAddress]);

  const changeBillFlag = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setBillFlag(checked);
  };

  const updateSelectedAddress = (address: Address) => {
    setSelectedAddress(address);
  };

  /**
   * @TrackType sensorsdata
   * @EventType MyAddressPageBtn_Click
   * @EventDesc 我的地址页按钮点击
   * @EventParams {
   *  btn_name: 按钮名称,
   *  entrance_payment_scene 进入支付页场景
   * }
   * @Tapd 1008875
   */
  const SDMyAddressPageBtnClick = (btn_name: string) => {
    try {
      const sdEventName = 'MyAddressPageBtn_Click';
      const sdEventParams = {
        entrance_payment_scene: entrancePaymentScene,
        btn_name,
        address_type: 'Billing Address',
      };
      trackEvent(
        {
          eventName: sdEventName,
          properties: sdEventParams,
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.log(e);
    }
  };

  /**
   * @TrackType sensorsdata
   * @EventType AddressEditPageBtn_Click
   * @EventDesc 地址编辑页按钮点击
   * @EventParams {
   *  btn_name: 按钮名称,
   * }
   * @Tapd 1008875
   */
  const SDAddressEditPageBtnClick = (btn_name: string, is_save_success = false) => {
    if (!entrancePaymentScene) return;
    const sdEventName = 'AddressEditPageBtn_Click';
    const sdEventParams = {
      btn_name,
      address_type: 'Billing Address',
      is_save_success,
      entrance_payment_scene: entrancePaymentScene,
    };
    trackEvent(
      {
        eventName: sdEventName,
        properties: sdEventParams,
      },
      [ProviderType.SENSORS],
    );
  };

  const SDAddressEditPageView = () => {
    if (!entrancePaymentScene) return;
    const sdEventName = 'AddressEditPage_View';
    const sdEventParams = {
      address_type: 'Billing Address',
      entrance_payment_scene: entrancePaymentScene,
      refer_page_name,
      refer_url_path,
    };
    trackEvent(
      {
        eventName: sdEventName,
        properties: sdEventParams,
      },
      [ProviderType.SENSORS],
    );
  };

  return (
    <div className="">
      <WebOnly>
        <div className="font-bb mb-16 text-[16px] md:text-[18px] opacity-0">
          {t('BillingAddress')}
        </div>
        <Checkbox
          checked={billFlag}
          onChange={changeBillFlag}
          label={
            <div className="font-br text-14 w-full">{t('useShippingAddressAsBillingAddress')}</div>
          }
          sx={{
            '& .MuiFormControlLabel-root': {
              marginRight: 0,
            },
          }}
        />
        {!billFlag && (
          <AddressComponentPc
            ref={addressComponentPcRef}
            withoutAddress={withoutAddress}
            shippingAddress={shippingAddress}
            addressList={addressList}
            selectedAddress={selectedAddress}
            SDMyAddressPageBtnClick={SDMyAddressPageBtnClick}
            countryIsSame={countryIsSame}
            paymentType={paymentType}
            updateSelectedAddress={updateSelectedAddress}
            SDAddressEditPageBtnClick={SDAddressEditPageBtnClick}
            SDAddressEditPageView={SDAddressEditPageView}
            handleUpdateAddressList={handleUpdateAddressList}
          />
        )}
      </WebOnly>
      <WapOnly>
        <div className="">
          <div className="font-bb text-[16px] md:text-18 border-b border-solid border-[#e2e2e2] pb-[18px]">
            {t('BillingAddress')}
          </div>

          <Checkbox
            checked={billFlag}
            onChange={changeBillFlag}
            label={
              <span className="font-br text-12">{t('useShippingAddressAsBillingAddress')}</span>
            }
          />
          {!billFlag && (
            <AddressComponentMobile
              // withoutAddress={withoutAddress}
              shippingAddress={shippingAddress}
              addressList={addressList}
              selectedAddress={selectedAddress}
              SDMyAddressPageBtnClick={SDMyAddressPageBtnClick}
              paymentType={paymentType}
              updateSelectedAddress={updateSelectedAddress}
              SDAddressEditPageBtnClick={SDAddressEditPageBtnClick}
              SDAddressEditPageView={SDAddressEditPageView}
              handleUpdateAddressList={handleUpdateAddressList}
            />
          )}
        </div>
      </WapOnly>
    </div>
  );
}
